import { tableOfContents } from 'Workspace/Publications/utils/constants';
const getMediaImportFormattedDate = () => {
  const date = new Date();
  const year = date.getFullYear();

  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  let day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  const time = date.toLocaleTimeString('en-US');

  return `${month}/${day}/${year} ${time}`;
};

/**
 * MediaImportNotes are used to populate the top of the BronteViewer media export spreadsheet
 * which is used by content creators for the XL sitebuilder.
 * 
 * Do not change anything in this unless previously agreed upon by product XL content team
 * as it may cause the import to fail.
 */

export const mediaImportNotes = [
  [`# Media Grid Import file generated ${getMediaImportFormattedDate()}`],
  ['#  '],
  ['# 1. Please ensure that the book code is specified in the appropriate field below.'],
  ['# 2. The Objective Number column may be omitted for books that do not use objectives.'],
  ['# 3. The Page Number column is optional and only applies to books that require it for '],
  ['#     adding media to the Multimedia Library.'],
  ['# 4. To create a new media asset, enter either empty or NEW in the Asset ID column. To update a media'],
  ['#     asset, specify the Asset ID of the media asset in this column.'],
  ['# 5. You can use a star in the chapter, section, or exercise columns to link media to'],
  ['#     multiple elements of the book at one time.  For example, to link a media asset to all exercises'],
  ['#     in Chapter 1, put a star in the Ex# Spec and Section columns. '],
  ['# 6. Use #-# to indicate a range. Surround the number signs with exercise numbers. Exercises'],
  ['#     will be processed based on their order numbers. For example, 2a#-#5 processes all'],
  ['#     exercises between number 2a and number 5, inclusive.'],
  ['# 7. The Pool column is used to specify whether the exercises referenced are TestGen'],
  ['#     exercises or Publisher exercises.  Put tb in this column for a TestGen exercise.'],
  ['#     Leave the column blank or enter P for a Publisher exercise. '],
  ['# 8. Valid Boolean values include Y, y, or 1 for yes and N, n, 0, or blank for no. Columns'],
  ['#     on this spreadsheet that accept Boolean values include:'],
  ['#     Section Level?: designates whether the media should be assigned to the given section.'],
  ['#     Multimedia Library?: designates whether media should be part of the Multimedia Library.'],
  ['#     SP Recommended?: designates whether asset should be study plan recommended'],
  ['#     Applies to all media links with the given asset (conflicting entries will not be accepted)'],
  ['# 9. If a % sign is present followed by a content type name for the Section Level? and Multimedia Library? columns,'],
  ['#     the content type specified takes precedence over the content type given in the ContentType'],
  ['#     column. The same Server, URL, and Title defined in the row are used. In this case, you should not'],
  ['#     put a y, Y, or 1 in the column.'],
  ['# 10. The Order column allows entry of order numbers and applies to Multimedia Library '],
  ['#     entries only.'],
  ['# 11. The Show Grapher? column is similar to the other Boolean columns with one exception.'],
  ['#      Leaving this column blank will have no effect on the current setting. Entering a yes'],
  ['#      or no value will show or hide the grapher learning aid for the specified exercise(s),'],
  ['#      respectively.'],
  ['# 12. The Width and Height columns are optional and only apply to Multimedia Library '],
  ['#     with special width and height.'],
  ['# 13. The Metadata columns are optional.  The values will be allowed to be uploaded for NEW media only.'],
  ['#     For existing media, the Media Update grid must be used.'],
  ['# 14. Set $REPLACEEXISTINGLEARNINGAIDS to TRUE to replace an existing learning aid for '],
  ['#     a question with the one being uploaded. For instance, use this setting if you would '],
  ['#     like to replace any question\'s Video learning aid with one listed in the new grid'],
  ["$FileType", "MediaImportGrid"],
  ["$Book"],
  ["$REPLACEEXISTINGLEARNINGAIDS", "FALSE"],
  ["Asset ID", "Ch#", "Sect#", "Obj#", "ContentType", "Server", "URL", "Title", "Ex# Spec", "Multimedia Library?", "Section Level?", "Page Number", "Pool", "Order", "Width", "Height", "SP Recommended?", "Show Grapher?", "Keywords", "Duration", "Creator", "Pearson Asset ID", "Language", "Publishing Country", "Permissions", "Downloadable", "Role Type", "Skill Code(s)", "Closed Captioning", "CC Location", "Transcript", "Transcript Location", "Compatibility", "Requires Flash", "Description"],
];

export const BVMediaExportFilename = 'BV_Media_Import_Non_Scored.csv';
export const BVMediaScoredExportFilename = 'BV_Media_Import_Scored.csv';

export const getElementTocLevel = (providedTocLevel) => {
  const tocLevel = providedTocLevel && typeof providedTocLevel === 'object'
    ? providedTocLevel.tocLevel
    : providedTocLevel;
  const tocLevelMap = {
    [tableOfContents.TWO_LEVELS]: '2',
    [tableOfContents.THREE_LEVELS]: '3',
  };
  if (typeof tocLevel === 'number') return String(tocLevel);

  return tocLevelMap[tocLevel] || tocLevel || '';
};

export const getSBMediaGridLineItem = (element, deploymentId, cohortId, env, providedTocLevel) => {
  const elementId = element?.activityId || element?.interactiveId;
  const tocLevelValue = getElementTocLevel(providedTocLevel);
  const tocLevel = tocLevelValue ? `&tocLevel=${tocLevelValue}` : '';

  return [
    "",
    "",
    "",
    "",
    "",
    "plugin.bronte",
    `deploymentId=${deploymentId}&cohortId=${cohortId}&elementId=${elementId}&env=${env}${tocLevel}`,
    `"${element.config?.title}"`,
  ];
};